/**
 * Do not edit directly
 * This file is auto-generated by scripts/generateReactIcon.js
 */

import React, { SVGProps } from 'react'

import {
  Ada,
  AddFile,
  AngleDown,
  AngleLeft,
  AngleRight,
  AngleUp,
  AnglesLeft,
  AnglesRight,
  ArrowLeft,
  ArrowRight,
  Bars,
  Bathtub,
  Bell,
  BellFilled,
  Bolt,
  BotHead,
  BotHeadCircle,
  BotHeadConstruction,
  Buoy,
  Buyers,
  BuyersFileuploader,
  Calculator,
  Calendar,
  CcAmex,
  CcDiscover,
  CcJcb,
  CcMastercard,
  CcVisa,
  ChartLine,
  Check,
  CheckBtb,
  CheckCircle,
  CheckCircleFa,
  CircleArrowDown,
  CircleArrowLeft,
  CircleArrowRight,
  CircleArrowRightBts,
  CircleArrowUp,
  CircularGraph,
  Clock,
  CloudRefresh,
  CloudUpload,
  CommentTextOutline,
  Commenting,
  CommentingFa,
  Condo,
  Copy,
  CreditCard,
  Database,
  DefaultAvatar,
  DmCircle,
  Dollar,
  DollarFi,
  Download,
  EllipsisH,
  EllipsisV,
  Emergency,
  Envelope,
  Equals,
  Exclamation,
  ExclamationCircle,
  ExclamationTriangle,
  ExternalLink,
  Eye,
  EyeEntypo,
  EyeSlash,
  FacebookOfficial,
  Film,
  Filter,
  Fire,
  Frown,
  FullscreenExit,
  FullscreenOpen,
  Gear,
  Globe,
  GraduationCap,
  GraphBar,
  Heart,
  HeartEmpty,
  Hexagon,
  Home,
  HomeAdd,
  HomeFav,
  Homeimprovement,
  Homeowners,
  HomeownersFileuploader,
  Info,
  InfoCircle,
  InfoCircleFa,
  Laptop,
  LightBulb,
  Link,
  Linkedin,
  Lo,
  Lock,
  LockMdc,
  LongArrowLeft,
  LongArrowRight,
  Loop,
  Magic,
  MapMarkedAlt,
  MapMarker,
  MapMarkerMdc,
  Message,
  Minus,
  MinusBtb,
  MinusCircle,
  Mobile,
  MultipleEnvelopes,
  NoData,
  NoPhoto,
  PaperPlane,
  PausedEnvelope,
  Pencil,
  Percent,
  Phone,
  Photo,
  Plane,
  Play,
  PlayCircleOutline,
  Plus,
  PlusBtb,
  PlusCircle,
  PointerClick,
  PricingBasic,
  PricingEnterprise,
  PricingPremium,
  QuestionCircle,
  RadioChecked,
  Rea,
  RecordVideo,
  Refi,
  Refresh,
  Rentalhome,
  Rentbuy,
  Rocket,
  Search,
  SearchBtm,
  Selling,
  Sellpocket,
  ShareArrow,
  Shower,
  SingleUser,
  Sink,
  Solar,
  SpinnerClock,
  Star,
  StarBts,
  ThumbsDown,
  ThumbsUp,
  Tilde,
  Times,
  TimesBtb,
  TimesCircle,
  Toilet,
  TorsoBusiness,
  Tradeup,
  Trash,
  TriangleDown,
  TriangleUp,
  Truck,
  TwoEnvelopes,
  Upload,
  Users,
  VideoCamera,
  Wallet,
  WalletEntypo,
  Wand,
  Wrench,
  WrenchFilled,
} from './svgrGeneratedIcons'

interface IconProps extends SVGProps<SVGElement> {
  'data-qa'?: string
  className?: string
  name: string
  title?: string
}

export const Icon = ({
  name,
  'data-qa': dataQa,
  className,
  'aria-hidden': ariaHidden = true,
  ...svgProps
}: IconProps) => {
  let Component

  switch (name) {
    case 'ada':
      Component = Ada
      break
    case 'add-file':
      Component = AddFile
      break
    case 'angle-down':
      Component = AngleDown
      break
    case 'angle-left':
      Component = AngleLeft
      break
    case 'angle-right':
      Component = AngleRight
      break
    case 'angle-up':
      Component = AngleUp
      break
    case 'angles-left':
      Component = AnglesLeft
      break
    case 'angles-right':
      Component = AnglesRight
      break
    case 'arrow-left':
      Component = ArrowLeft
      break
    case 'arrow-right':
      Component = ArrowRight
      break
    case 'bars':
      Component = Bars
      break
    case 'bathtub':
      Component = Bathtub
      break
    case 'bell':
      Component = Bell
      break
    case 'bell-filled':
      Component = BellFilled
      break
    case 'bolt':
      Component = Bolt
      break
    case 'bot-head':
      Component = BotHead
      break
    case 'bot-head-circle':
      Component = BotHeadCircle
      break
    case 'bot-head-construction':
      Component = BotHeadConstruction
      break
    case 'buoy':
      Component = Buoy
      break
    case 'buyers':
      Component = Buyers
      break
    case 'buyers-fileuploader':
      Component = BuyersFileuploader
      break
    case 'calculator':
      Component = Calculator
      break
    case 'calendar':
      Component = Calendar
      break
    case 'cc-amex':
      Component = CcAmex
      break
    case 'cc-discover':
      Component = CcDiscover
      break
    case 'cc-jcb':
      Component = CcJcb
      break
    case 'cc-mastercard':
      Component = CcMastercard
      break
    case 'cc-visa':
      Component = CcVisa
      break
    case 'chart-line':
      Component = ChartLine
      break
    case 'check':
      Component = Check
      break
    case 'check-btb':
      Component = CheckBtb
      break
    case 'check-circle':
      Component = CheckCircle
      break
    case 'check-circle-fa':
      Component = CheckCircleFa
      break
    case 'circle-arrow-down':
      Component = CircleArrowDown
      break
    case 'circle-arrow-left':
      Component = CircleArrowLeft
      break
    case 'circle-arrow-right':
      Component = CircleArrowRight
      break
    case 'circle-arrow-right-bts':
      Component = CircleArrowRightBts
      break
    case 'circle-arrow-up':
      Component = CircleArrowUp
      break
    case 'circular-graph':
      Component = CircularGraph
      break
    case 'clock':
      Component = Clock
      break
    case 'cloud-refresh':
      Component = CloudRefresh
      break
    case 'cloud-upload':
      Component = CloudUpload
      break
    case 'comment-text-outline':
      Component = CommentTextOutline
      break
    case 'commenting':
      Component = Commenting
      break
    case 'commenting-fa':
      Component = CommentingFa
      break
    case 'condo':
      Component = Condo
      break
    case 'copy':
      Component = Copy
      break
    case 'credit-card':
      Component = CreditCard
      break
    case 'database':
      Component = Database
      break
    case 'default-avatar':
      Component = DefaultAvatar
      break
    case 'dm-circle':
      Component = DmCircle
      break
    case 'dollar':
      Component = Dollar
      break
    case 'dollar-fi':
      Component = DollarFi
      break
    case 'download':
      Component = Download
      break
    case 'ellipsis-h':
      Component = EllipsisH
      break
    case 'ellipsis-v':
      Component = EllipsisV
      break
    case 'emergency':
      Component = Emergency
      break
    case 'envelope':
      Component = Envelope
      break
    case 'equals':
      Component = Equals
      break
    case 'exclamation':
      Component = Exclamation
      break
    case 'exclamation-circle':
      Component = ExclamationCircle
      break
    case 'exclamation-triangle':
      Component = ExclamationTriangle
      break
    case 'external-link':
      Component = ExternalLink
      break
    case 'eye':
      Component = Eye
      break
    case 'eye-entypo':
      Component = EyeEntypo
      break
    case 'eye-slash':
      Component = EyeSlash
      break
    case 'facebook-official':
      Component = FacebookOfficial
      break
    case 'film':
      Component = Film
      break
    case 'filter':
      Component = Filter
      break
    case 'fire':
      Component = Fire
      break
    case 'frown':
      Component = Frown
      break
    case 'fullscreen-exit':
      Component = FullscreenExit
      break
    case 'fullscreen-open':
      Component = FullscreenOpen
      break
    case 'gear':
      Component = Gear
      break
    case 'globe':
      Component = Globe
      break
    case 'graduation-cap':
      Component = GraduationCap
      break
    case 'graph-bar':
      Component = GraphBar
      break
    case 'heart':
      Component = Heart
      break
    case 'heart-empty':
      Component = HeartEmpty
      break
    case 'hexagon':
      Component = Hexagon
      break
    case 'home':
      Component = Home
      break
    case 'home-add':
      Component = HomeAdd
      break
    case 'home-fav':
      Component = HomeFav
      break
    case 'homeimprovement':
      Component = Homeimprovement
      break
    case 'homeowners':
      Component = Homeowners
      break
    case 'homeowners-fileuploader':
      Component = HomeownersFileuploader
      break
    case 'info':
      Component = Info
      break
    case 'info-circle':
      Component = InfoCircle
      break
    case 'info-circle-fa':
      Component = InfoCircleFa
      break
    case 'laptop':
      Component = Laptop
      break
    case 'light-bulb':
      Component = LightBulb
      break
    case 'link':
      Component = Link
      break
    case 'linkedin':
      Component = Linkedin
      break
    case 'lo':
      Component = Lo
      break
    case 'lock':
      Component = Lock
      break
    case 'lock-mdc':
      Component = LockMdc
      break
    case 'long-arrow-left':
      Component = LongArrowLeft
      break
    case 'long-arrow-right':
      Component = LongArrowRight
      break
    case 'loop':
      Component = Loop
      break
    case 'magic':
      Component = Magic
      break
    case 'map-marked-alt':
      Component = MapMarkedAlt
      break
    case 'map-marker':
      Component = MapMarker
      break
    case 'map-marker-mdc':
      Component = MapMarkerMdc
      break
    case 'message':
      Component = Message
      break
    case 'minus':
      Component = Minus
      break
    case 'minus-btb':
      Component = MinusBtb
      break
    case 'minus-circle':
      Component = MinusCircle
      break
    case 'mobile':
      Component = Mobile
      break
    case 'multiple-envelopes':
      Component = MultipleEnvelopes
      break
    case 'no-data':
      Component = NoData
      break
    case 'no-photo':
      Component = NoPhoto
      break
    case 'paper-plane':
      Component = PaperPlane
      break
    case 'paused-envelope':
      Component = PausedEnvelope
      break
    case 'pencil':
      Component = Pencil
      break
    case 'percent':
      Component = Percent
      break
    case 'phone':
      Component = Phone
      break
    case 'photo':
      Component = Photo
      break
    case 'plane':
      Component = Plane
      break
    case 'play':
      Component = Play
      break
    case 'play-circle-outline':
      Component = PlayCircleOutline
      break
    case 'plus':
      Component = Plus
      break
    case 'plus-btb':
      Component = PlusBtb
      break
    case 'plus-circle':
      Component = PlusCircle
      break
    case 'pointer-click':
      Component = PointerClick
      break
    case 'pricing-basic':
      Component = PricingBasic
      break
    case 'pricing-enterprise':
      Component = PricingEnterprise
      break
    case 'pricing-premium':
      Component = PricingPremium
      break
    case 'question-circle':
      Component = QuestionCircle
      break
    case 'radio-checked':
      Component = RadioChecked
      break
    case 'rea':
      Component = Rea
      break
    case 'record-video':
      Component = RecordVideo
      break
    case 'refi':
      Component = Refi
      break
    case 'refresh':
      Component = Refresh
      break
    case 'rentalhome':
      Component = Rentalhome
      break
    case 'rentbuy':
      Component = Rentbuy
      break
    case 'rocket':
      Component = Rocket
      break
    case 'search':
      Component = Search
      break
    case 'search-btm':
      Component = SearchBtm
      break
    case 'selling':
      Component = Selling
      break
    case 'sellpocket':
      Component = Sellpocket
      break
    case 'share-arrow':
      Component = ShareArrow
      break
    case 'shower':
      Component = Shower
      break
    case 'single-user':
      Component = SingleUser
      break
    case 'sink':
      Component = Sink
      break
    case 'solar':
      Component = Solar
      break
    case 'spinner-clock':
      Component = SpinnerClock
      break
    case 'star':
      Component = Star
      break
    case 'star-bts':
      Component = StarBts
      break
    case 'thumbs-down':
      Component = ThumbsDown
      break
    case 'thumbs-up':
      Component = ThumbsUp
      break
    case 'tilde':
      Component = Tilde
      break
    case 'times':
      Component = Times
      break
    case 'times-btb':
      Component = TimesBtb
      break
    case 'times-circle':
      Component = TimesCircle
      break
    case 'toilet':
      Component = Toilet
      break
    case 'torso-business':
      Component = TorsoBusiness
      break
    case 'tradeup':
      Component = Tradeup
      break
    case 'trash':
      Component = Trash
      break
    case 'triangle-down':
      Component = TriangleDown
      break
    case 'triangle-up':
      Component = TriangleUp
      break
    case 'truck':
      Component = Truck
      break
    case 'two-envelopes':
      Component = TwoEnvelopes
      break
    case 'upload':
      Component = Upload
      break
    case 'users':
      Component = Users
      break
    case 'video-camera':
      Component = VideoCamera
      break
    case 'wallet':
      Component = Wallet
      break
    case 'wallet-entypo':
      Component = WalletEntypo
      break
    case 'wand':
      Component = Wand
      break
    case 'wrench':
      Component = Wrench
      break
    case 'wrench-filled':
      Component = WrenchFilled
      break
    default:
      new Error('No such icon.')
  }

  return (
    <Component
      data-qa={dataQa}
      className={className}
      aria-hidden={ariaHidden}
      {...svgProps}
    />
  )
}

export const AVAILABLE_ICONS = [
  'ada',
  'add-file',
  'angle-down',
  'angle-left',
  'angle-right',
  'angle-up',
  'angles-left',
  'angles-right',
  'arrow-left',
  'arrow-right',
  'bars',
  'bathtub',
  'bell',
  'bell-filled',
  'bolt',
  'bot-head',
  'bot-head-circle',
  'bot-head-construction',
  'buoy',
  'buyers',
  'buyers-fileuploader',
  'calculator',
  'calendar',
  'cc-amex',
  'cc-discover',
  'cc-jcb',
  'cc-mastercard',
  'cc-visa',
  'chart-line',
  'check',
  'check-btb',
  'check-circle',
  'check-circle-fa',
  'circle-arrow-down',
  'circle-arrow-left',
  'circle-arrow-right',
  'circle-arrow-right-bts',
  'circle-arrow-up',
  'circular-graph',
  'clock',
  'cloud-refresh',
  'cloud-upload',
  'comment-text-outline',
  'commenting',
  'commenting-fa',
  'condo',
  'copy',
  'credit-card',
  'database',
  'default-avatar',
  'dm-circle',
  'dollar',
  'dollar-fi',
  'download',
  'ellipsis-h',
  'ellipsis-v',
  'emergency',
  'envelope',
  'equals',
  'exclamation',
  'exclamation-circle',
  'exclamation-triangle',
  'external-link',
  'eye',
  'eye-entypo',
  'eye-slash',
  'facebook-official',
  'film',
  'filter',
  'fire',
  'frown',
  'fullscreen-exit',
  'fullscreen-open',
  'gear',
  'globe',
  'graduation-cap',
  'graph-bar',
  'heart',
  'heart-empty',
  'hexagon',
  'home',
  'home-add',
  'home-fav',
  'homeimprovement',
  'homeowners',
  'homeowners-fileuploader',
  'info',
  'info-circle',
  'info-circle-fa',
  'laptop',
  'light-bulb',
  'link',
  'linkedin',
  'lo',
  'lock',
  'lock-mdc',
  'long-arrow-left',
  'long-arrow-right',
  'loop',
  'magic',
  'map-marked-alt',
  'map-marker',
  'map-marker-mdc',
  'message',
  'minus',
  'minus-btb',
  'minus-circle',
  'mobile',
  'multiple-envelopes',
  'no-data',
  'no-photo',
  'paper-plane',
  'paused-envelope',
  'pencil',
  'percent',
  'phone',
  'photo',
  'plane',
  'play',
  'play-circle-outline',
  'plus',
  'plus-btb',
  'plus-circle',
  'pointer-click',
  'pricing-basic',
  'pricing-enterprise',
  'pricing-premium',
  'question-circle',
  'radio-checked',
  'rea',
  'record-video',
  'refi',
  'refresh',
  'rentalhome',
  'rentbuy',
  'rocket',
  'search',
  'search-btm',
  'selling',
  'sellpocket',
  'share-arrow',
  'shower',
  'single-user',
  'sink',
  'solar',
  'spinner-clock',
  'star',
  'star-bts',
  'thumbs-down',
  'thumbs-up',
  'tilde',
  'times',
  'times-btb',
  'times-circle',
  'toilet',
  'torso-business',
  'tradeup',
  'trash',
  'triangle-down',
  'triangle-up',
  'truck',
  'two-envelopes',
  'upload',
  'users',
  'video-camera',
  'wallet',
  'wallet-entypo',
  'wand',
  'wrench',
  'wrench-filled',
]

Icon.displayName = 'Icon'
